import { useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { referralLinkAtom } from '@root/entities/referral'
import { ReferralCodeActions } from '@root/features/referral/ui/desktop/common/referral-code-actions'
import { Drawer } from '@root/shared/ui-kit'

import type { DrawerProps } from '@root/shared/ui-kit'

type Props = Pick<DrawerProps, 'onOpenChange' | 'open'>

export const InviteReferralDrawer: React.FC<Props> = ({
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation()
  const [referralLink] = useAtom(referralLinkAtom)

  return (
    <Root
      open={open}
      onOpenChange={onOpenChange}
      title={t('referral.invite_referral')}
    >
      <Content>
        {referralLink ? (
          <Actions>
            <ReferralCodeActions referralLink={referralLink} />
          </Actions>
        ) : undefined}
      </Content>
    </Root>
  )
}

const Root = styled(Drawer)``
const Actions = styled.div`
  display: grid;
  gap: 10px;
`
const Content = styled.div`
  padding-inline: 16px;
  padding-block: 8px 50px;
`
